import React from "react";
import { Radio, Steps } from "antd";
import { useHistory } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

function Stepper(props) {
  let history = useHistory();

  return (
    <div>
      <Steps
        style={{ marginBottom: 20 }}
        size="small"
        items={[
          {
            title: "Open",
            status: props.status === "OPEN" ? "process" : "finish",
            icon: props.status === "OPEN" ? <LoadingOutlined /> : false,
          },
          {
            title: "Update",
            status:
              props.status === "READY"
                ? "process"
                : props.status === "OPEN"
                ? "wait"
                : "finish",
            icon: props.status === "READY" ? <LoadingOutlined /> : false,
          },

          {
            title: "Writeoff",
            status: props.status === "COMPLETE" ? "finish" : "wait",
            icon: props.status === "ISSUED" ? <LoadingOutlined /> : false,
          },
        ]}
      />
    </div>
  );
}

export default Stepper;
